import api from "./api";

export const CREDITS_EVENT = "rammy-credits-changed";

/** Anything that spends credits should announce it so the chip stays honest. */
export function announceCreditsChanged() {
  window.dispatchEvent(new Event(CREDITS_EVENT));
}

export async function fetchCredits() {
  const { data } = await api.get("/credits/me");
  return data;
}

export function fmtCredits(n) {
  return Number(n || 0).toLocaleString();
}

/** True when an error is the "you're out of credits" 402. */
export function isCreditError(err) {
  return err?.response?.status === 402 &&
    err?.response?.data?.detail?.error === "insufficient_credits";
}
